import { PrePaymentFrequencyOption } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { AsyncStore } from './AsyncStore';
import { computed, makeObservable } from 'mobx';

export class PaymentFrequencyStore extends AsyncStore<PrePaymentFrequencyOption[]> {
    constructor(apiClient: IApiClient) {
        super(() => apiClient.getPaymentFrequencies(), []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
